const env = process.env as Record<string, string>;

const Config = {
  SERVER: {
    URL: env.REACT_APP_API_URL,
    ENV: env.NODE_ENV,
  },
  ENV: env.NODE_ENV,
};

export const { SERVER } = Config;
